export default "__VITE_ASSET__c647c470__"